import React, { useEffect, useState } from "react";
import { Dimensions, Platform, StyleSheet, View } from "react-native";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { BottomBarDLSType, ButtonSizeDLS, ButtonTypeDLS, ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import BottomBar from "../../bottomBarDLS/bottomBarDLS";
import ThemeProvider from "@voltmoney/theme";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { Space } from "../../space/Space";
import { addSuffix, isMobile, isMobileViewApp } from "../../stack/utils";
import BottomSheet from "../BottomSheet";
import { addCommasToNumber, getLenderIcon, getScreenType } from "../utils";
import { Button } from "../../button/Button";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import CustomHeader from "../../customHeader/CustomHeader";
const LoanRenewalVerifySummaryPage = ({ offerSelectionInitData, ctaAction, height, needHelpAction, goBackAction, lender, triggerAction, isLoading }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [_offerSelectionInitData, setOfferSelectionInitData] = useState(offerSelectionInitData);
    const [showInfo, setShowInfo] = useState(false);
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const lenderIcon = getLenderIcon(lender);
    const isFromMobileViewApp = isMobileViewApp();
    const _isFontMobile = () => {
        if (Platform.OS !== "web") {
            return true;
        }
        else if (isFromMobileViewApp) {
            return true;
        }
        else {
            return false;
        }
    };
    const isFontMobile = _isFontMobile();
    useEffect(() => {
        setIsBtnLoading(isLoading);
    }, [isLoading]);
    const renderDivider = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: {
                    width: '100%',
                    height: 1,
                    backgroundColor: colorMapping[ColorTokens.Grey_Milk_1]
                } }),
            React.createElement(Space, { size: SizeTypeTokens.XL })));
    };
    const renderCreditLimitCard = () => {
        const creditAmount = _offerSelectionInitData?.creditLimit ? addCommasToNumber(_offerSelectionInitData?.creditLimit) : _offerSelectionInitData?.creditLimit;
        const pledgedPortfolioValue = _offerSelectionInitData?.pledgedPortfolioValue ? addCommasToNumber(_offerSelectionInitData?.pledgedPortfolioValue) : _offerSelectionInitData?.pledgedPortfolioValue;
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    padding: 16,
                    backgroundColor: colorMapping[ColorTokens.White],
                    borderTopWidth: 1,
                    borderTopColor: colorMapping[ColorTokens.Primary_10],
                    borderBottomWidth: 1,
                    borderBottomColor: colorMapping[ColorTokens.Primary_10],
                } },
                React.createElement(Typography, { label: 'Credit limit', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    } },
                    React.createElement(Typography, { label: `₹`, fontWeight: '700', color: ColorTokens.Secondary_100, fontSize: isFontMobile ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile ? 40 : 32 }),
                    React.createElement(Typography, { label: `${creditAmount}`, typeDLS: TypographyTypeDLS.H1B, color: ColorTokens.Secondary_100 })),
                renderDivider(),
                React.createElement(Typography, { label: 'Mutual fund value', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.XS }),
                React.createElement(Typography, { label: `₹${pledgedPortfolioValue}`, typeDLS: TypographyTypeDLS.B0B, color: ColorTokens.Grey_Night }))));
    };
    const renderInterestAndOtherCharges = () => {
        const interestRate = _offerSelectionInitData?.interestRate;
        const processingCharges = _offerSelectionInitData?.processingCharges;
        return (React.createElement(View, null,
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                } },
                React.createElement(Typography, { label: 'Interest and other charges', typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night })),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(View, { style: {
                    backgroundColor: colorMapping[ColorTokens.White],
                    padding: 16,
                    borderTopWidth: 1,
                    borderTopColor: colorMapping[ColorTokens.Primary_10],
                    borderBottomWidth: 1,
                    borderBottomColor: colorMapping[ColorTokens.Primary_10],
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    } },
                    React.createElement(Typography, { label: 'Interest rate', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                    React.createElement(Typography, { label: `${interestRate}%`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })),
                renderDivider(),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    } },
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        } },
                        React.createElement(Typography, { label: 'Renewal fees (excl. of GST)', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night })),
                    React.createElement(Typography, { label: `₹${processingCharges}`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })))));
    };
    const renderRepaymentSchedule = () => {
        const tenure = _offerSelectionInitData?.tenure;
        const interestAutoPay = _offerSelectionInitData?.interestAutoPay;
        const principalRepaymentMode = _offerSelectionInitData?.principalRepaymentMode;
        return (React.createElement(View, null,
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                } },
                React.createElement(Typography, { label: 'Repayment schedule', typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night })),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(View, { style: {
                    backgroundColor: colorMapping[ColorTokens.White],
                    padding: 16,
                    borderTopWidth: 1,
                    borderTopColor: colorMapping[ColorTokens.Primary_10],
                    borderBottomWidth: 1,
                    borderBottomColor: colorMapping[ColorTokens.Primary_10],
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    } },
                    React.createElement(Typography, { label: 'Tenure', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                    React.createElement(Typography, { label: `${tenure} months`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })),
                renderDivider(),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    } },
                    React.createElement(Typography, { label: 'Interest autopay', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                    React.createElement(Typography, { label: `${interestAutoPay}${addSuffix(interestAutoPay)} of every month`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })),
                renderDivider(),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    } },
                    React.createElement(Typography, { label: 'Principal repayment', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                    React.createElement(Typography, { label: `${principalRepaymentMode}`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })))));
    };
    const renewalFeeModalRender = () => {
        const renewalFee = _offerSelectionInitData?.processingChargesBreakup["Processing Fee"] || 0;
        const gstFee = _offerSelectionInitData?.processingChargesBreakup["Stamp Duty (as per reg. state)*"] || 0;
        const totalFee = renewalFee + gstFee;
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0, marginBottom: -4, zIndex: 2 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: Platform.OS === "ios" ? 342 : isMobile(getScreenType(Dimensions.get('window').width)) ? 315 : 310, width: '100%', closeFunction: () => {
                    setShowInfo(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true },
                React.createElement(View, { style: { paddingHorizontal: 16, paddingTop: 24, paddingBottom: 16 } },
                    React.createElement(Typography, { label: "Renewal charges", typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night }),
                    React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                    React.createElement(View, { style: {
                            padding: 12,
                            borderRadius: 12,
                            borderWidth: 1,
                            borderColor: colorMapping[ColorTokens.Grey_Chalk],
                            backgroundColor: colorMapping[ColorTokens.White]
                        } },
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(Typography, { label: 'Renewal fee', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { label: `₹${renewalFee}`, typeDLS: TypographyTypeDLS.B1M })),
                        renderDivider(),
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(Typography, { label: 'GST @ 18%', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { label: `₹${gstFee}`, typeDLS: TypographyTypeDLS.B1M })),
                        renderDivider(),
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(Typography, { label: 'Total', typeDLS: TypographyTypeDLS.B1S }),
                            React.createElement(Typography, { label: `₹${totalFee}`, typeDLS: TypographyTypeDLS.B1S }))),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", sizeDLS: ButtonSizeDLS.MEDIUM, onPress: () => {
                                setShowInfo(false);
                            } }))))));
    };
    const body = () => {
        return (React.createElement(View, { style: [
                styles.bodycontainer
            ] },
            renderCreditLimitCard(),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            renderInterestAndOtherCharges(),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            renderRepaymentSchedule(),
            React.createElement(Space, { size: SizeTypeTokens.XXL })));
    };
    const footer = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(BottomBar, { onPress: async () => {
                    !isBtnLoading &&
                        ctaAction &&
                        await triggerAction(ctaAction);
                }, btnLoading: isBtnLoading, btnLabel: 'Proceed', typeDLS: BottomBarDLSType.TYPE_B, btnTypeDLS: ButtonTypeDLS.PRIMARY, isPositionAbsolute: false, children: React.createElement(View, { style: {
                        borderRadius: 4,
                        borderColor: '#E4E7EC',
                        flexDirection: 'row',
                        borderWidth: 1,
                        alignSelf: 'center',
                        alignItems: 'center',
                    } },
                    React.createElement(View, { style: {
                            borderRightWidth: 1,
                            padding: 8,
                            borderRightColor: '#E4E7EC',
                            justifyContent: 'center',
                            alignContent: 'center',
                            alignItems: 'center',
                        } },
                        React.createElement(Typography, { label: 'Lending partner', fontSize: FontSizeTokens.XXS, fontWeight: '400', lineHeight: 16, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal })),
                    React.createElement(View, { style: { paddingHorizontal: 8 } },
                        React.createElement(Icon, { name: lenderIcon, color: ColorTokens.Grey_Charcoal }))) })));
    };
    return (
    // <View style={[
    //     {
    //         height: height
    //     }
    // ]}>
    //     <ScrollView style={{
    //         flex: 1
    //     }}>
    //         {
    //             body()
    //         }
    //     </ScrollView>
    //     {
    //         showInfo && renewalFeeModalRender()
    //     }
    //     {
    //         footer()
    //     }
    // </View>
    React.createElement(React.Fragment, null,
        React.createElement(BoilerPlate, { height: height, headerChild: React.createElement(React.Fragment, null,
                React.createElement(CustomHeader, { title: 'Verify renewal summary', needHelpAction: needHelpAction, goBackAction: goBackAction, triggerAction: triggerAction })), bottomChildren: React.createElement(React.Fragment, null, footer()), backgroundColor: ColorTokens.Primary_05 },
            React.createElement(React.Fragment, null, body())),
        showInfo && renewalFeeModalRender()));
};
const styles = StyleSheet.create({
    bodycontainer: {
        paddingTop: 16,
        flex: 1
    },
});
export default LoanRenewalVerifySummaryPage;
